import axios from "axios";
import { saveNotificationRequestStore } from "../../../../../helpers/store/NotificationRequestStore";

const notificationFcmBackend = axios.create({
  baseURL: process.env.REACT_APP_API_NOTIFICATION_URL,
});

export const SendNotificationsDriverV2 = async ({
  notifyTo,
  orderNumber,
  latitude,
  longitude,
}) => {
  try {
    const response = await notificationFcmBackend.post(
      "/api/v1/notification/fcm/driver",
      {
        serviceTo: "CLIENT",
        notifyTo,
        orderNumber: Number(orderNumber),
        latitude,
        longitude,
      },
    );

    const notificationRequest = response?.data?.data;
    if (notificationRequest?.requestId && notificationRequest?.orderNumber) {
      saveNotificationRequestStore({
        requestId: Number(notificationRequest.requestId),
        orderNumber: Number(notificationRequest.orderNumber),
      });
    }

    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
